<template>
  <component :is="tag" class="page-generic">
    <div
      v-for="section in blok.body"
      :key="section._uid"
      class="section-inner section-contained"
    >
      <StoryblokComponent :blok="section" />
    </div>
  </component>
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});
</script>

<style lang="scss" scoped>
.page-generic .section-inner {
  margin: 2rem 0;
  &:first-child {
    margin-top: 0;
  }
}
</style>
